import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NoSleep from 'nosleep.js/dist/NoSleep.min';

import BaseChat from '../../base/Chat/index';

import ConnectionStatePopup from '../ConnectionStatePopup/index';
import RoomClosedPopup from '../RoomClosedPopup/index';
import SidebarLeft from '../SidebarLeft/index';
import ContainerCenter from '../ContainerCenter/index';
import CameraAccess from '../CameraAccess/index';
import SidebarRight from '../SidebarRight/index';
import MobileOverlay from '../MobileOverlay/index';
import RestartIndicator from '../RestartIndicator/index';


import Registry from '../../../registry/index';
import {ROOM_TYPE_PERSONAL} from '../../../constants/rooms';
import {VIDEO_OPEN_USER_VIDEO} from '../../../constants/streaming';
import AnonymousLoginPopup from '../AnonymousLoginPopup';
import AnonymousSession from '../../../anonymousSession';
import { getCookie, setCookie } from '../../../utils';

import AnonymousLoginPopup_connect from '../AnonymousLoginPopup';

import Popup from '../Popup/index';
import CookieConsentBanner from "../CookieConsentBanner/CookieConsentBanner";

class NeoChat extends BaseChat {
    constructor(props) {
        super(props);

        let {browser} = props;

        this.state = {
            sidebarLeftShown: !browser.mobile,
            sidebarRightShown: !browser.mobile,
        };

        this.autoLoginAnonymous = this.autoLoginAnonymous.bind(this);
        this.onAnonymousSessionExpire = this.onAnonymousSessionExpire.bind(this);
        this.openVideoByExternalMessage = this.openVideoByExternalMessage.bind(this);
        this.setDisclaimer = this.setDisclaimer.bind(this);
    }

    componentDidMount() {
        ConnectionStatePopup.mount({ store: this.props.store });
        RoomClosedPopup.mount({ store: this.props.store });

        window.addEventListener('message', this.openVideoByExternalMessage);
        window.addEventListener('ageverif:success', this.setDisclaimer);

        let noSleep = new NoSleep();
        // Enable wake lock.
        document.addEventListener('click', function enableNoSleep() {
            document.removeEventListener('click', enableNoSleep, false);
            noSleep.enable();
            console.log('noSleep enabled');
        }, false);

        let chatInterface = Registry.get('chatInterface');

        if (chatInterface.isAnonymous()) {
            if(chatInterface.isVideoOpenRequested()) {
                // Do not show, only mount
                AnonymousLoginPopup.mount({store: this.props.store});
                this.autoLoginAnonymous();
            } else {
                // Show
                AnonymousLoginPopup.open({store: this.props.store});
            }
        } else {
            if (!chatInterface.isCertified()) {
            // Do not show, only mount
                AnonymousLoginPopup.mount({store: this.props.store});
            }
            chatInterface.login();
        }

        const VISITED = getCookie('VISITED') || '';
        if (!VISITED) AnonymousLoginPopup_connect.open({store: this.props.store});
        setTimeout(() => {
            const { currentUser } = this.props;
            if (typeof window.openAnonymousPopupTab !== 'function') {
                window.openAnonymousPopupTab = function (tabIndex = 0) {
                    const id = AnonymousLoginPopup_connect.generateKey();
                    const popupInstance = Popup.popups[id];
                    popupInstance.switchTab(tabIndex);
                    if (currentUser.nick) popupInstance.open();
                };
            }
        }, 500);
    }

    setDisclaimer(forced = false) {
        const { currentUser } = this.props;
        const siteInterface = Registry.get('siteInterface');

        if (window.ageverif &&
            window.ageverif.verified &&
            currentUser &&
            currentUser.age_verified === 0) {
            siteInterface.ageVerifUser();
        }

        if ((window.ageverif && window.ageverif.verified) || forced) {
            const VISITED = getCookie('VISITED') || '';
            const entries = VISITED.split(',').filter(entry => entry !== '');
            entries.push('/disclaimer/');

            setCookie('VISITED', entries.join(','), 86400);

            this.setState({ showModalDisclaimer: false });
        }

        if (typeof window.closeDisclaimer === 'function') {
            window.closeDisclaimer();
        }
    }

    openVideoByExternalMessage(event) {
        //console.log("message", event.data);

        let chatInterface = Registry.get('chatInterface');
        let { data } = event;
        let { store, currentRoom } = this.props;

        if (data.action === 'openVideoWindow') {

            if(data.roomid && data.roomid !== currentRoom.id) {
                //store.dispatch({type: ROOM_SWITCHED, id: event.data.roomid, exists: true});

                chatInterface.loginVirtualRoom(
                    data.roomid,
                    '',
                    () => {
                        window.setTimeout(function() {
                            store.dispatch({type: VIDEO_OPEN_USER_VIDEO, ufrag: data.ufrag});
                        }, 1000);
                    },
                    () => {}
                );

            } else if(data.ufrag) {
                store.dispatch({type: VIDEO_OPEN_USER_VIDEO, ufrag: data.ufrag});
            }
        }
    }

    autoLoginAnonymous() {
        let chatInterface = Registry.get('chatInterface');

        let anonymousSession = new AnonymousSession(() => {});

        if(anonymousSession.remaining <= 0) {
            this.onAnonymousSessionExpire();
        } else {
            let that = this;
            let random_nick = btoa(Math.random()).substr(6, 6);
            chatInterface.setGuestNick(random_nick);
            chatInterface.login(
                (_response) => anonymousSession.start(that.onAnonymousSessionExpire),
                () => {}
            );
        }

    }

    onAnonymousSessionExpire() {
        let chatInterface = Registry.get('chatInterface');
        if(chatInterface.isLoggedIn()) chatInterface.logout();
        AnonymousLoginPopup.open({store: this.props.store});
    }

    componentWillUpdate(nextProps, nextState) {
        let htmlClasses = document.documentElement.classList;

        let currentUser = this.props.currentUser,
            nextCurrentUser = nextProps.currentUser;

        if (currentUser.isXXL() && !nextCurrentUser.isXXL()) {
            htmlClasses.remove('xxl');
        }

        if (!currentUser.isXXL() && nextCurrentUser.isXXL()) {
            htmlClasses.add('xxl');
        }
    }

    render() {
        const { mobile } = this.props.browser;

        return (
            <section className="content-old">
                <SidebarLeft/>
                <ContainerCenter/>
                <SidebarRight/>
                <MobileOverlay/>
                {!mobile ? <CameraAccess /> : null}
                <RestartIndicator />
                <CookieConsentBanner />
            </section>
        );
    }
}

NeoChat.contextTypes = {
    store: PropTypes.object
};

function mapStateToProps(state) {
    return {
        browser: state.browser,
        currentUser: state.currentUser,
        currentRoom: state.currentRoom,
    };
}

export default connect(mapStateToProps)(NeoChat);




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/NeoChat/index.js